import src from "IMAGE";
export default { src, width: 430, height: 430, blurWidth: 0, blurHeight: 0};
